// Google Ads conversion tracking utility
export const trackConversion = (conversionId, value = 1.0, currency = 'EUR') => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'conversion', {
      'send_to': `AW-16965968030/${conversionId}`,
      'value': value,
      'currency': currency
    });
  }
};

// Predefined conversion events
export const conversions = {
  // Page Views
  pageView: 'KoksCL_y9bEaEJ7BgJo_',
  pageView1: 'ZAHdCMLy9bEaEJ7BgJo_',
  
  // User Actions
  signUp: 'signup_conversion_id', // Replace with actual conversion ID
  login: 'login_conversion_id',   // Replace with actual conversion ID
  subscriptionInitiation: 'subscription_initiation_conversion_id', // Replace with actual conversion ID
  subscriptionSuccess: 'subscription_success_conversion_id', // Replace with actual conversion ID
  
  // Feature Usage
  costExplorer: 'cost_explorer_conversion_id', // Replace with actual conversion ID
  guides: 'guides_conversion_id',             // Replace with actual conversion ID
  taskManager: 'task_manager_conversion_id',   // Replace with actual conversion ID
};

// Endorsly affiliate tracking utility - simplified according to official instructions
// Endorsly automatically tracks events when window.endorsely_referral is present
export const trackEndorslyConversion = (eventType, value = null, currency = 'EUR') => {
  // According to Endorsly instructions, affiliate tracking should work regardless of general consent
  // when a user comes through an affiliate link (has endorsely_referral)
  if (typeof window !== 'undefined' && window.endorsely_referral) {
    // Endorsly will automatically track this event
    // No manual function calls needed
    // Note: Endorsly cookie is whitelisted for affiliate tracking per instructions
  }
};

// Enhanced tracking functions
export const analytics = {
  // User Authentication
  trackSignUp: () => {
    try {
      trackConversion(conversions.signUp);
      trackEndorslyConversion('signup');
    } catch (error) {
      console.warn('Analytics tracking failed:', error);
      // Continue execution - don't break the user flow
    }
  },
  trackLogin: () => trackConversion(conversions.login),
  trackSubscriptionInitiation: (value) => trackConversion(conversions.subscriptionInitiation, value),
  trackSubscriptionSuccess: (value) => {
    try {
      trackConversion(conversions.subscriptionSuccess, value);
      trackEndorslyConversion('subscription', value);
    } catch (error) {
      console.warn('Analytics tracking failed:', error);
    }
  },
  
  // Feature Usage
  trackCostExplorer: () => trackConversion(conversions.costExplorer),
  trackGuides: () => trackConversion(conversions.guides),
  trackTaskManager: () => trackConversion(conversions.taskManager),
  
  // Page Views
  trackPageView: () => trackConversion(conversions.pageView),
  trackPageView1: () => trackConversion(conversions.pageView1),
  
}; 